import Swal from "sweetalert2";

export const successAlert = (title, text) => {
  return Swal.fire({
    icon: "success",
    title: title || "Success!",
    text: text || "Operation completed successfully",
    confirmButtonColor: "#3085d6",
  });
};

export const errorAlert = (title, text) => {
  return Swal.fire({
    icon: "error",
    title: title || "Error!",
    text: text || "Something went wrong",
    confirmButtonColor: "#d33",
  });
};

export const confirmAlert = (options) => {
  return Swal.fire({
    title: options.title || "Are you sure?",
    text: options.text || "",
    icon: options.icon || "warning",
    showCancelButton: options.showCancelButton !== false,
    confirmButtonText: options.confirmButtonText || "Yes",
    cancelButtonText: options.cancelButtonText || "Cancel",
    confirmButtonColor: options.confirmButtonColor || "#3085d6",
    cancelButtonColor: options.cancelButtonColor || "#d33",
    reverseButtons: options.reverseButtons || false,
  });
};

export const loadingAlert = (message) => {
  return Swal.fire({
    title: message || "Please wait...",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

export const closeAlert = () => {
  Swal.close();
};
